export type BooleanAttr = boolean | string | null;

/**
 * Converts an attribute to a boolean
 */
export function attrToBool<T>(attr: T) {
  if (typeof attr === "boolean") {
    return attr;
  }
  if (typeof attr === "string") {
    return attr === "true" || attr === "";
  }
  return !!attr;
}

/**
 * Converts an attribute to a number
 */
export function attrToNumber<T>(attr: T) {
  return Number(attr);
}

/**
 * Creates a short content-based hash
 */
export function hash(value: string) {
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    let char = value.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0;
  }
  return hash;
}

/**
 * Flattens a list of options. Used option groups need to be
 * flattened into an array for easy parsing
 */
export function flattenOptions<T>(options: T[]) {
  return options.flatMap((o) =>
    // @ts-ignore
    Array.isArray(o.options) ? (o.options as T[]) : o
  );
}

/**
 * Builds an asset URL using environment context.
 */
export function getAssetsUrl(fileName: string) {
  if (/^data:image/.test(fileName)) return fileName;
  // process.env.IMPORT_META_URL is replaced at build time
  // based on the build target (import.meta.url for web
  // builds and the CDN url for npm builds)
  // https://github.com/facebook/jest/issues/11634
  const base = (process.env.IMPORT_META_URL ?? "/").replace(/\/modules.*/, "");
  return [base, fileName].map((p) => p.replace(/^\/|\/$/, "")).join("/");
}
